"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.nav.dashboard': 'Pulpit',
    'socialMediaPlan.nav.channels': 'Kanały',
    'socialMediaPlan.nav.analytics': 'Analityka',
};
